import dynamic from 'next/dynamic';
import { useIsMobile } from '~/context/common/DeviceContext';

const YourSelectionsPanelMobile = dynamic(
  () => import('./YourSelectionsPanelMobile')
);
const YourSelectionsPanelNonMobile = dynamic(
  () => import('./YourSelectionsPanelNonMobile')
);

export default function YourSelectionsPanel() {
  const isMobile = useIsMobile();

  return isMobile ? (
    <YourSelectionsPanelMobile />
  ) : (
    <YourSelectionsPanelNonMobile />
  );
}
